import StoreCatalog from '../../../../components/StoreCatalog'
export default function StoreDefaultTemplate(props) { return <StoreCatalog {...props} style="default" /> }
